export const TUS_CATEGORY_MISSION_FILES = 'files/missions';
